import gql from "graphql-tag";

import { cornermarkFragment } from "./cornermark";
import { instagramNoProductFragment } from "./instagram";
import { metadataFragment } from "./metadata";
import { taxTypeFragment } from "./taxes";
import { weightFragment } from "./weight";

export const stockFragment = gql`
  fragment StockFragment on Stock {
    id
    quantity
    quantityAllocated
    warehouse {
      id
      name
    }
  }
`;

export const fragmentMoney = gql`
  fragment Money on Money {
    amount
    currency
  }
`;

export const fragmentProductImage = gql`
  fragment ProductImageFragment on ProductImage {
    id
    alt
    sortOrder
    isVisible
    url
  }
`;

export const productFragment = gql`
  fragment ProductFragment on Product {
    id
    name
    thumbnail {
      url
    }
    isAvailable
    isPublished
    isPreOrder
    preOrder
    productType {
      id
      name
      hasVariants
    }
    defaultVariant {
      id
      sku
    }
  }
`;

export const productVariantAttributesFragment = gql`
  ${fragmentMoney}
  fragment ProductVariantAttributesFragment on Product {
    id
    attributes {
      attribute {
        id
        slug
        name
        inputType
        valueRequired
        values {
          id
          name
          slug
        }
      }
      values {
        id
        name
        slug
      }
    }
    productType {
      id
      variantAttributes {
        id
        name
        values {
          id
          name
          slug
        }
      }
    }
    pricing {
      priceRangeUndiscounted {
        start {
          gross {
            ...Money
          }
        }
        stop {
          gross {
            ...Money
          }
        }
      }
    }
  }
`;
export const productInsFrament = gql`
  ${instagramNoProductFragment}
  fragment ProductInsFrament on InstagramProduct {
    id
    sortOrder
    imgUrl
    userName
    insId
    published
    visible
    instagram {
      ...InstagramNoProductFragment
    }
  }
`;
export const productFragmentDetails = gql`
  ${fragmentProductImage}
  ${fragmentMoney}
  ${productVariantAttributesFragment}
  ${stockFragment}
  ${weightFragment}
  ${metadataFragment}
  ${taxTypeFragment}
  ${cornermarkFragment}
  ${productFragment}
  fragment Product on Product {
    ...ProductVariantAttributesFragment
    ...MetadataFragment
    name
    slug
    description
    descriptionJson
    seoTitle
    seoKeyword
    seoDescription
    isPreOrder
    preOrder
    lensTypeTemplate
    producttagsSpu {
      id
      name
    }
    producttagsSku {
      id
      name
    }
    thumbnail {
      url
    }
    defaultVariant {
      id
    }
    category {
      id
      name
    }
    collections {
      id
      name
    }
    margin {
      start
      stop
    }
    purchaseCost {
      start {
        ...Money
      }
      stop {
        ...Money
      }
    }
    care
    isAvailableForPurchase
    isAvailable
    isPublished
    chargeTaxes
    publicationDate
    pricing {
      priceRangeUndiscounted {
        start {
          gross {
            ...Money
          }
        }
        stop {
          gross {
            ...Money
          }
        }
      }
    }
    imagesDas {
      ...ProductImageFragment
    }
    variants {
      id
      variantId
      sku
      variantId
      name
      isPublished
      price {
        ...Money
      }
      costPrice {
        ...Money
      }
      margin
      stocks {
        ...StockFragment
      }
      trackInventory
      weight {
        ...WeightFragment
      }
      cornerMark {
        ...CornermarkFragment
      }
      thumbnail {
        url
      }
    }

    productType {
      id
      name
      hasVariants
      taxType {
        ...TaxTypeFragment
      }
    }
    weight {
      ...WeightFragment
    }
    taxType {
      ...TaxTypeFragment
    }
    USP
    availableForPurchase
    visibleInListings
    recommendProducts(showDefault: true) {
      ...ProductFragment
    }
    alsoLikeProducts(showDefault: true) {
      ...ProductFragment
    }
    buyTogetherProducts(showDefault: true) {
      ...ProductFragment
    }
  }
`;

export const fragmentVariant = gql`
  ${fragmentMoney}
  ${fragmentProductImage}
  ${stockFragment}
  ${weightFragment}
  ${metadataFragment}
  ${cornermarkFragment}
  fragment ProductVariant on ProductVariant {
    id
    created
    firstPublicationDate
    ...MetadataFragment
    extrachargeCategoryName
    extraChargeCategory {
      categoryName
      category
    }
    variantId
    attributes {
      attribute {
        id
        name
        slug
        valueRequired
        values {
          id
          name
          slug
        }
      }
      values {
        id
        name
        slug
      }
    }
    skuAttributes {
      attribute {
        id
        name
        slug
        valueRequired
        values {
          id
          name
          slug
        }
      }
      values {
        id
        name
        slug
      }
    }
    costPrice {
      ...Money
    }
    images {
      id
      url
      isFirst
      urlType
      isVisible
    }
    thumbnail {
      url
    }
    name
    isPublished
    publicationDate
    isAvailableForPurchase
    availableForPurchase
    isPreOrder
    preOrder
    extraCharge
    fromColor
    toColor
    isTwoColor
    colorThumbnail
    shortDescription
    fullDescription
    describe
    USP
    framesImg
    framesVideo
    skuName
    slug
    seoTitle
    seoKeyword
    seoDescription
    colorTagText
    colorTagBackground
    colorTagTextColor
    # colorTagIcon
    productvarianttagsSku {
      id
      name
    }
    price {
      ...Money
    }
    product {
      id
      defaultVariant {
        id
      }
      images {
        ...ProductImageFragment
      }
      name
      thumbnail {
        url
      }
      variants {
        id
        name
        variantId
        sku
        images {
          id
          url
          isFirst
          isVisible
        }
        thumbnail {
          url
        }
        isPublished
      }
      defaultVariant {
        id
      }
    }
    sku
    stocks {
      ...StockFragment
    }
    trackInventory
    weight {
      ...WeightFragment
    }
    cornerMark {
      ...CornermarkFragment
    }
  }
`;

export const exportFileFragment = gql`
  fragment ExportFileFragment on ExportFile {
    id
    status
    url
  }
`;
